/**
 * Centralised query keys for all API queries.
 *
 * Keeping every key factory in one file makes it easy to find, avoids
 * circular imports between query and mutation files, and mirrors the
 * influenster-v4-mobile pattern.
 */

export const campaignKeys = {
  all: ['campaigns'] as const,
  lists: () => [...campaignKeys.all, 'list'] as const,
  list: (filters: string) => [...campaignKeys.lists(), { filters }] as const,
  details: () => [...campaignKeys.all, 'detail'] as const,
  detail: (id: number) => [...campaignKeys.details(), id] as const,
  guidance: (id: number) => [...campaignKeys.all, 'guidance', id] as const,
  invite: (token: string) => ['invite', token] as const,
};

export const memberInfoKeys = {
  all: ['memberInfo'] as const,
  detail: () => [...memberInfoKeys.all, 'detail'] as const,
};

export const profilePictureKeys = {
  all: ['profilePicture'] as const,
  detail: (memberId: number) => [...profilePictureKeys.all, 'detail', memberId] as const,
};

export const profileKeys = {
  all: ['profile'] as const,
  detail: () => [...profileKeys.all, 'detail'] as const,
};

export const addressKeys = {
  all: ['addresses'] as const,
  verified: () => [...addressKeys.all, 'verified'] as const,
};

export const socialConnectionsKeys = {
  all: ['socialConnections'] as const,
  list: () => [...socialConnectionsKeys.all, 'list'] as const,
};

export const updateEmailKeys = {
  all: ['updateEmail'] as const,
};
